export type BrandingDatapointId =
  | 'metadata'
  | 'ref'
  | 'name'
  | 'teams' // skip for PPL
  | 'class_of_business'
  | 'date_created_at'
  | 'time_created_at'
  | 'date_updated_at'
  | 'time_updated_at'
  | 'created_by.name'
  | 'datapoints'
  | 'data_items.risk_details.unique_market_reference.unique_market_reference'
  | 'data_items.risk_details.unique_market_reference.placing_broker_unique_identifier'
  | 'page_counter'
  | 'pageNumber'
  | 'totalPages';

export enum SummaryDatapointId {
  // Form datapoints
  Policyholders = 'data_items.risk_details.policyholder',
  UniqueMarketReference = 'data_items.risk_details.unique_market_reference.unique_market_reference',
  OriginalInsured = 'data_items.risk_details.original_insured',
  // Endorsement datapoints
  DateCreatedAt = 'created_at',
  DateUpdatedAt = 'updated_at',
  EffectiveDate = 'effective_date',
  EndorsementReason = 'reason',
  EndorsementReference = 'reference',
  EndorsementType = 'type',
  ExpiryDate = 'expiry_date',
  PremiumAmount = 'additional_premium.amount',
  PremiumChange = 'premium_change',
  PremiumCurrency = 'additional_premium.currency',
  TimeCreatedAt = 'created_at_time',
  TimeUpdatedAt = 'updated_at_time',
}
